import DataGrid, { Column } from "devextreme-react/data-grid";
import TotalOVTCell from "./TotalOVTCell";

export default function GridTemplate({ dataSource = [] }) {
  return (
    <div>
      <DataGrid
        dataSource={dataSource}
        // showColumnHeaders={false}
        showRowLines={false}
      >
        <Column dataField="fullName" />
        <Column dataField="totalHours" />
        <Column
          dataField="totalHours"
          dataType="number"
          alignment="right"
          allowGrouping={true}
          cellRender={TotalOVTCell}
          cssClass="bullet"
          caption="Bar Graph"
        />
      </DataGrid>
    </div>
  );
}
